export default __webpack_public_path__ + "static/media/heroimage-device.817e0203.jpeg";